import { privateAxios } from '../requestsCollection';
import { IResponse } from '../types';
import {
  IAddCrisisAllocationPayload,
  ICrisisAllocation,
  ICrisisCall,
  ICrisisCallsAllocatedClients,
  ICrisisCallTeamMember,
  IEditCrisisAddressPayload,
  IEditManualCrisisAllocationAddressPayload,
  IManualCrisisAllocationPayload,
} from './types';

export const addCrisisAllocation = (
  clinicId: string,
  data: IAddCrisisAllocationPayload,
): IResponse<ICrisisAllocation> =>
  privateAxios(
    {
      method: 'post',
      url: `clinic/${clinicId}/crisis-allocation`,
      data,
    },
    'v3',
  );

export const createManualCrisisAllocation = (
  clinicId: string,
  data: IManualCrisisAllocationPayload,
): IResponse<ICrisisAllocation> =>
  privateAxios(
    {
      method: 'post',
      url: `clinic/${clinicId}/manual-crisis-allocation`,
      data,
    },
    'v3',
  );

export const deleteCrisisAllocation = (clinicId: string, id: number): IResponse<void> =>
  privateAxios(
    {
      method: 'delete',
      url: `clinic/${clinicId}/crisis-allocation/${id}`,
    },
    'v3',
  );

export const editCrisisAllocation = (
  clinicId: string,
  id: string,
  memo: string,
): IResponse<ICrisisAllocation> =>
  privateAxios(
    {
      method: 'put',
      url: `clinic/${clinicId}/crisis-allocation/${id}`,
      data: { memo },
    },
    'v3',
  );

export const getCrisisCalls = (clinicId: string): IResponse<{ crisisCalls: ICrisisCall[] }> =>
  privateAxios({
    method: 'get',
    url: `clinic/${clinicId}/crisis-call`,
  });

export const crisisCallResolve = (
  clinicId: number,
  crisisCallId: number,
  memo: string,
): IResponse<{ crisisCalls: ICrisisCall[] }> =>
  privateAxios({
    method: 'patch',
    url: `clinic/${clinicId}/crisis-call/${crisisCallId}/resolve`,
    data: { memo },
  });

export const getCrisisCallsTeamMembers = (clinicId: string): IResponse<ICrisisCallTeamMember[]> =>
  privateAxios({
    method: 'get',
    url: `clinic/${clinicId}/crisis-call/team-members`,
  });

export const editCrisisAddress = (
  clinicId: number,
  id: number,
  data: IEditCrisisAddressPayload,
): IResponse<ICrisisCall> =>
  privateAxios({
    method: 'put',
    url: `clinic/${clinicId}/crisis-call/${id}/address`,
    data,
  });

export const editManualCrisisAllocationAddress = (
  clinicId: string,
  followUpAllocationId: number,
  data: IEditManualCrisisAllocationAddressPayload,
): IResponse<ICrisisCallsAllocatedClients> =>
  privateAxios(
    {
      method: 'put',
      url: `clinic/${clinicId}/manual-crisis-allocation/${followUpAllocationId}/address`,
      data,
    },
    'v3',
  );

export default {};
